import { actionCreator } from "../../../state/utils";

import type { INavItem } from "./reducer";

export const RegisterNavItemActionCreator = actionCreator<"REGISTER_NAV_ITEM", Omit<INavItem, "children">>(
  "REGISTER_NAV_ITEM"
);
export const SetNavExpandedActionCreator = actionCreator<"SET_NAV_EXPANDED", boolean>("SET_NAV_EXPANDED");
export const SetDarkModeActionCreator = actionCreator<"SET_DARK_MODE", boolean>("SET_DARK_MODE");

export type FrameActions =
  | ReturnType<typeof RegisterNavItemActionCreator>
  | ReturnType<typeof SetNavExpandedActionCreator>
  | ReturnType<typeof SetDarkModeActionCreator>;
